import { connect } from 'react-redux';

import { getIsHotelOnly, getIsMobile } from 'src/store/view/selectors';

import {
  getHotelFacts,
  getActualizationShowModalCustomer,
} from 'checkout/store/selectors/actualization';
import { submitTourists } from 'checkout/store/actions/tourists';
import {
  getOrderClientConfirmed,
  getIsOrderPrebuildFetching,
  getIsOrderPrebuilt,
} from 'checkout/store/selectors/order';
import { getAdultsCount, makeGetKids } from 'checkout/store/selectors/package';
import { touristsSelector } from 'src/store/tourists/selectors';
import {
  getValidations,
  getInProgress,
} from 'checkout/store/domains/tourists-checkout-validation/slice';

import {
  isCustomerInfoValidSelector,
  mobileCustomerFormVisibleSelector,
} from 'src/routes/Checkout/store/domains/customer/selectors';
import { isValidSelector } from 'src/store/touristsValidation/selectors';
import { Tourists } from './Tourists';

const mapStateToProps = (state) => ({
  isNewValidationTourist: isValidSelector(state),
  mobileCustomerFormVisible: mobileCustomerFormVisibleSelector(state),
  adultsCount: getAdultsCount(state),
  kidsAges: makeGetKids(state),
  isClientConfirmed: getOrderClientConfirmed(state),
  isPrebuildFetching: getIsOrderPrebuildFetching(state),
  isPrebuilt: getIsOrderPrebuilt(state),
  isTouristPassportValidationInProgress: getInProgress(state),
  touristsPassportValidations: getValidations(state),
  tourists: touristsSelector(state),
  hotelFacts: getHotelFacts(state),
  isHotelOnly: getIsHotelOnly(state),
  isMobile: getIsMobile(state),
  isCustomerInfoValid: isCustomerInfoValidSelector(state),
  showModalCustomer: getActualizationShowModalCustomer(state),
});

const mapDispatchToProps = {
  submit: submitTourists,
};

export default connect(mapStateToProps, mapDispatchToProps)(Tourists);
